export const PRELOAD_TIMEOUT = 500;

export type MouseTraceEntry = {
	x: number;
	y: number;
	t: number;
};

export type MouseTrace = {
	entries: Array<MouseTraceEntry>;
	timestamp: number;
	modelVersion?: string;
	leaveProbability?: number;
};

export type MouseTraceModel = {
	version: string;
	distanceWeight: number;
	speedWeight: number;
	xRangeWeight: number;
	yRangeWeight: number;
	threshold: number;
	stats: {
		distance: { mean: number; stdDev: number };
		speed: { mean: number; stdDev: number };
		xRange: { mean: number; stdDev: number };
		yRange: { mean: number; stdDev: number };
	};
};
